import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../services/apiServices";

// Async Thunks

// Fetch all serialized stocks
export const fetchSerializedStocks = createAsyncThunk(
    "serializedStock/fetchSerializedStocks",
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiServices.get("serializedStock");
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error fetching serialized stocks");
        }
    }
);

// Delete serialized stock
export const deleteSerializedStock = createAsyncThunk(
    "serializedStock/deleteSerializedStock",
    async (id, { rejectWithValue }) => {
        try {
            await apiServices.delete(`serializedStock/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error deleting serialized stock");
        }
    }
);

const serializedStockSlice = createSlice({
    name: "serializedStock",
    initialState: {
        items: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSerializedStocks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSerializedStocks.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchSerializedStocks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteSerializedStock.fulfilled, (state, action) => {
                state.items = state.items.filter((item) => item._id !== action.payload);
            });
    },
});

export default serializedStockSlice.reducer;
